module.exports = __webpack_public_path__ + "img/ilustration-forgot.6dfdf91c.svg";